<div style="font-size: 16px !important" class="p-4">
    <form nz-form nz-row [formGroup]="adjustTimesheetForm" class="ppl-p0 mt-2">
        <table class="table">
            <thead>
                <tr>
                    <th style="background-color: #a8e4e14d; width: 10%;">Service Date</th>
                    <th style="background-color: #a8e4e14d; width: 15%;">Service Description</th>
                    <th style="background-color: #a8e4e14d; width: 10%;">Time In</th>
                    <th style="background-color: #a8e4e14d; width: 10%;">Time Out</th>
                    <th style="background-color: #a8e4e14d; width: 10%;">Current MCO</th>
                    <th style="background-color: #a8e4e14d; width: 10%;">Current Auth Number</th>
                    <th style="background-color: #a8e4e14d; width: 15%;">New MCO/Auth Number</th>
                    <th style="background-color: #a8e4e14d; width: 15%;">Reason *</th>
                </tr>
            </thead>
            <tbody formArrayName="billingEntries">
                <tr *ngFor="let entry of billingEntries.controls; let i = index" [formGroupName]="i">
                    <td>
                        <div class="pt-4 pl-5"><span>{{entry.get('serviceDate')?.value | dateWithDayOfWeek}}</span>
                        </div>
                    </td>
                    <td>
                        <div class="pt-4 pl-5"><span>{{entry.get('serviceDescription')?.value}}</span></div>
                    </td>
                    <td>
                        <div class="pt-4 pl-5"><span>{{entry.get('serviceTimeIn')?.value}}</span></div>
                    </td>
                    <td>
                        <div class="pt-4 pl-5"><span>{{entry.get('serviceTimeOut')?.value}}</span></div>
                    </td>
                    <td>
                        <div class="pt-4 pl-5"><span>{{entry.get('mco')?.value}}</span></div>
                    </td>
                    <td>
                        <div class="pt-4 pl-5"><span>{{entry.get('authNumber')?.value}}</span></div>
                    </td>

                    <td>
                        <div style="width: 100%;" class="filters" [ngClass]="{'error':entry.get('mcoName')?.invalid && (entry.get('mcoName')?.touched || submitRequested)}">
                            <ppl-dropdown-select formControlName="mcoName" id="mcoName" [placeholder]="'MCO'"
                            [options]="getAuthorizations(entry.get('timesheetId')?.value)" [optionLabel]="'label'" [optionValue]="'value'">
                            </ppl-dropdown-select>
                        </div>

                        <div style="margin-left: 8px; margin-right: 8px;width: 100%;"
                            *ngIf="entry.get('mcoName')?.invalid && (entry.get('mcoName')?.touched || submitRequested) && !entry.get('mcoName')?.errors?.['customError']">
                            <div class="error-message">Please select a MCO</div>
                        </div>
                        <div style="margin-left: 8px; margin-right: 8px;width: 100%;"
                        *ngIf="entry.get('mcoName')?.errors?.['customError']">
                            <div class="error-message">{{ entry.get('mcoName')?.errors?.['customError'] }}</div>
                        </div>
                    </td>
                    <td>
                        <div style="width: 100%;" class="filters" [ngClass]="{'error': entry.get('reason')?.invalid && (entry.get('reason')?.touched || submitRequested) }">
                            <ppl-dropdown-select formControlName="reason" id="reason" placeholder="Select Reason"
                            [options]="reasonList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
                            </ppl-dropdown-select>
                        </div>
                        <div style="margin-left: 8px; margin-right: 8px;width: 100%;"
                            *ngIf="entry.get('reason')?.invalid && (entry.get('reason')?.touched || submitRequested)">
                            <div class="error-message">Please select a reason.</div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </form>

    <div class="custom-row" style="width: 100%;">
        <ppl-button (click)="onAdjustClick()" style="margin-right: 8px;" label="Submit Adjustment" icon="fa fa-check-circle"
            [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
    </div>
</div>